import React from 'react';
import { Text, RichText, Image, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import ArticleCardNPM from '@rotaryintl/component-article-card';
import { createLink } from '../../utilities/link-helpers';
import { GetFormattedDate } from '../../utilities/date-helper-functions';

const ArticleCard = ({ sitecoreContext, fields: { Title, Text: TextField, Date: DateField, Image: ImageField, Link, LinkText } = {} }) => {
  return (
    <ArticleCardNPM
      title={<Text field={Title} />}
      text={<RichText field={TextField} />}
      image={<Image field={ImageField} />}
      date={GetFormattedDate(sitecoreContext?.language?.toLowerCase(), new Date(DateField?.value))}
      link={createLink(Link, LinkText)}
    />
  );
};

export default withSitecoreContext()(ArticleCard);
